async function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  document.execCommand('copy');
  document.body.removeChild(ta);
}

function showInlineFeedback(btn) {
  const feedback = btn.querySelector('.copy-feedback');
  if (!feedback) return;
  if (feedback.dataset.timeoutId) clearTimeout(Number(feedback.dataset.timeoutId));
  feedback.textContent = 'Copied!';
  const id = setTimeout(() => {
    feedback.textContent = '';
    delete feedback.dataset.timeoutId;
  }, 1500);
  feedback.dataset.timeoutId = String(id);
}

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-copy]');
  if (!btn) return;
  e.preventDefault();
  try {
    await copyText(btn.dataset.copy);
    showInlineFeedback(btn);
  } catch (err) {
    console.error('Copy failed:', err);
  }
});
